import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as agendaRoutes } from './agenda/routes';
import { routes as masterAiRoutes } from './master_ai/routes';
import { routes as iaComercialRoutes } from './ia_comercial/routes';
import { routes as superFuncionariosRoutes } from './super_funcionarios/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as kanbanRoutes } from './kanban/kanban.routes';
import { routes as conversionsRoutes } from './conversions/routes';
import { routes as socialHubRoutes } from './social_hub/routes';
import { routes as ticketsRoutes } from './tickets/tickets.routes';
import { routes as playbookRoutes } from './playbook/playbook.routes';
import contractsRoutes from './contracts/contracts.routes';
import { routes as commissionsRoutes } from './commissions/routes';
import { routes as productsRoutes } from './products/routes';
import { routes as catalogRoutes } from './catalog/routes';
import { routes as sicManagerRoutes } from './sic_manager/sic_manager.routes';
import { routes as clawAgentsRoutes } from './claw_agents/routes';
import { routes as iaEntrevistaRoutes } from './ia_entrevista/routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...agendaRoutes,
        ...masterAiRoutes,
        ...iaComercialRoutes,
        ...superFuncionariosRoutes,
        ...iaEntrevistaRoutes,
        ...kanbanRoutes,
        ...conversionsRoutes,
        ...socialHubRoutes,
        ...ticketsRoutes,
        ...playbookRoutes,
        ...contractsRoutes.routes,
        ...commissionsRoutes,
        ...productsRoutes,
        ...catalogRoutes,
        ...sicManagerRoutes,
        ...clawAgentsRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
